export const SubCategoryFilterCaption = 'Sub Category';
export const NfoCategoryFilterCaption = 'NFO Category';
export const DurationFilterCaption = 'Return Duration';
export const AxisSelectFilterCaption = 'Show Only Axis Bank Select';
export const AxisSelectToolTipCaption = 'The shortlisted funds on the basis of quantitative and qualitative parameters';
export const FundFilters = [
  {
    key: 'Equity',
    subCategories: [
      { name: 'Multicap' },
      { name: 'Largecap' },
      { name: 'Midcap' },
      { name: 'Large and Midcap Fund' },
      { name: 'Small cap' },
      { name: 'Focused' },
      { name: 'ELSS' },
      { name: 'More' },
    ],
    durations: [{ name: '1Y' }, { name: '3Y' }, { name: '5Y' }, { name: '10Y' }],
  },
  {
    key: 'Hybrid',
    subCategories: [
      { name: 'Conservative' },
      { name: 'Aggressive' },
      { name: 'Dynamic Asset Allocation' },
      { name: 'Multi asset allocation Arbitrage' },
      { name: 'Equity Savings' },
      { name: 'More' },
    ],
    durations: [{ name: '1Y' }, { name: '3Y' }, { name: '5Y' }, { name: '10Y' }],
  },
  {
    key: 'Debt',
    subCategories: [
      { name: 'Short Duration (1-3 yrs)' },
      { name: 'Med to long duration (4-7 yrs)' },
      { name: 'Long duration (7+ yrs)' },
      { name: 'Dynamic Bond (across duration & credit)' },
      { name: 'Corporate Bond (highest rated corporate bonds)' },
      { name: 'Banking & PSU' },
      { name: 'Gilt (Govt Securities)' },
      { name: 'More' },
    ],
    durations: [{ name: '1Y' }, { name: '3Y' }, { name: '5Y' }, { name: '10Y' }],
  },
  {
    key: 'Liquid',
    subCategories: [
      { name: 'Overnight Fund (1 day)' },
      { name: 'Ultra short term (3-6 months)' },
      { name: 'Money market (up to 1 yr)' },
      { name: 'Liquid (up to 91 days)' },
      { name: 'Low duration (6-12 months)' },
      { name: 'More' },
    ],
    durations: [{ name: '1M' }, { name: '6M' }, { name: '1Y' }, { name: '3Y' }],
  },
  {
    key: 'Others',
    subCategories: [
      { name: 'Index Funds' },
      { name: 'Gold Funds' },
      { name: 'Solution Oriented' },
      { name: 'Fund of Funds (International/Domestic)' },
    ],
    durations: [{ name: '1Y' }, { name: '3Y' }, { name: '5Y' }, { name: '10Y' }],
  },
];
export const Invest = 'Invest';
export const Details = 'Details';
export const NAV = 'NAV';
export const Return = 'Return';
export const ViewAll = 'VIEW ALL';

export const fundTypes = [
  {
    categoryCode: 'Equity',
    category: 'Equity',
    categoryName: 'Equity Funds for wealth creation',
    categoryDescription:
      'Equity funds enable you to invest in stocks of listed companies. Equity funds may be volatile in the short term, but hold the potential to deliver superior returns over time.',
    icon: 'EquityIcon',
  },
  {
    category: 'Debt',
    categoryCode: 'Debt',
    categoryName: 'Debt Funds for wealth preservation',
    categoryDescription:
      'These invest in debt instruments (eg: corporate bonds, government securities). Debt funds are relatively less volatile and hence ideal for risk-averse investors',
    icon: 'DebtIcon',
  },
  {
    category: 'Hybrid',
    categoryCode: 'Hybrid',
    categoryName: 'Hybrid Funds for diversifying your investments across equity & debt',
    categoryDescription:
      'A combination of equity and debt, these funds enable diversifying your investment across 2 or more asset classes thereby giving a flavour of multiple assets in one single investment.',
    icon: 'HybridIcon',
  },
  {
    category: 'Liquid',
    categoryCode: 'Liquid',
    categoryName: 'Liquid Funds for parking surplus cash',
    categoryDescription:
      'These carry lowest interest-rate risk and are ideal for first-time investors. Use these funds as a stepping stone to invest in equity/debt/hybrid funds',
    icon: 'LiquidIcon',
  },
  {
    category: 'Others',
    categoryCode: 'Other',
    categoryName: 'Others',
    categoryDescription: 'Explore international, index & retirement funds, and other Fund-of-Funds (FoFs).',
    icon: 'OtherIcon',
  },
];

export const EXPLORE_PAGE_TYPE = {
  ALL_MUTUAL_FUNDS: 'All_Mutual_Funds',
  INVEST_IDEAS: 'Invest_Ideas',
  SAVE_TAX: 'Save_Tax',
};

export const returnDurationSaveTax = [
  {
    displayName: '1Y',
    displayText: '',
    key: 'oneYear',
  },
  {
    displayName: '3Y',
    displayText: '',
    key: 'threeYear',
  },
  {
    displayName: '5Y',
    displayText: '',
    key: 'fiveYear',
  },
];
export const returnDuration = [
  {
    displayName: '1Y',
    displayText: '',
    key: 'oneYear',
  },
  {
    displayName: '3Y',
    displayText: '',
    key: 'threeYear',
  },
  {
    displayName: '5Y',
    displayText: '',
    key: 'fiveYear',
  },
  // {
  //   displayName: '10Y',
  //   displayText: '',
  //   key: 'tenYear',
  // },
];

export const saveTaxTooltipContent =
  'These are also called Tax saving equity funds.They carry a lock-in period of 3 years and offer tax exemption upto Rs 1.5Lakhs under section 80C  of the IT ACT';

export const SAVE_TAX_SUB_CAT = 'ELS';
export const OTHER_FUND = 'Other';
export const ERROR_IN_FETCHING_SCHEMES = 'Facing error in fetching the schemes';
export const NA_RISK = 'NA';
export const EXPLORE_SCHEMES_USER_FLOW = {
  EXPLORE: 'EXPLORE',
  SAVE_TAX: 'SAVE_TAX',
  INVESTMENT_IDEAS: 'INVESTMENT_IDEAS',
  PLAN_GOALS_WITH_SIP: 'PLAN_GOALS_WITH_SIP',
  INVEST_MORE: 'INVEST_MORE', // Will be used for transact page via Invest more
  INVEST_BASIS_RISK_PROFILE: 'INVEST_BASIS_RISK_PROFILE',
  NFO: 'NFO',
};
export const HOME = 'Home';
export const LANDING_SCREEN = 'Landing Screen';
export const TOTAL_CARDS_IN_MOBILE = 3;
export const TOTAL_CARDS_IN_WEB = 5;
export const SECONDARY_HOLDER_INVESTMENT_ID_ERROR = `You hold the investment account in joint mode hence transaction is not allowed. Under Joint mode of holding, transaction allowed only under primary holder’s login.`;
export const JOINT_INVESTMENT_ID_ERROR = `Dear customer, you hold the investment account in joint mode. Purchase transactions in a new folio under joint holding pattern are temporarily suspended through online mode owing to new SEBI guidelines on Nomination. Please contact your relationship manager / nearest branch for executing the same through physical mode. We regret the inconvenience.`;
export const CHOOSE_NOMINEE_DETAILS_ERROR = `Please choose nominee details to continue.`;
export const CART_PAGE_REFERRER_SUBCATEGORY = 'international funds';
export const MF_BANNER_NAME = `SIP Banner`;
export const JOINT_HOLDER_WITH_NO_FOLIO_ERROR = `Dear customer, you hold the investment account in joint mode of holding hence transaction in new folio is not possible.`;
export const SI_MODE_OF_OPERATION = `Dear customer, you have selcted the investment account in joint mode of holding hence transaction in new folio is not possible. To complete the transaction in new folio, please select single mode of holding investment ID and then proceed with transaction.`;
export const NOMINEE_DETAILS_ERROR_NOTE = `To nominate, please visit the nearest Axis Bank branch or contact your RM. Alternately, the completed nomination form can be submitted to the respective AMC/RTA.`;
export const MULTIPLE_INVESTMENT_ID_ERROR =
  'Dear Customer, we request you to contact your Relationship Manager or nearest Axis Bank branch to complete the one-time registration process, to enable online transaction for mutual funds.';
export const HOLD_AND_RT_OLD_FOLIO = `Dear Customer, as per the revised regulatory guidelines, you are required to do a re-KYC with KYC
Registration Agency (KRA). We request you to complete the re-KYC by visiting below link or contact RM or
visit nearest Axis Bank branch to know more.`;
export const RT_NEW_FOLIO = `Dear Customer, as per the revised regulatory guidelines, you are required to do a re-KYC with KYC Registration Agency (KRA). We request you to complete the re-KYC by visiting below link or click on “Proceed” to continue with transaction. Please note there may be rejection of transaction by AMC if re- KYC is not completed.`;
